<template>
  <b-popover
    :target="'tooltip-info-fleet-' + fleetNumber"
    triggers="hover"
    placement="lefttop"
    custom-class="custom-tooltip p-0 overflow-hidden"
  >
    <div class="fleet-popover-header">
      <span class="mc-text-fleet-number">{{ fleetNumber }}</span>
    </div>
    <hr class="separator" />
    <div class="fleet-popover-body">
      <div class="__title">
        {{ $t('fleetTaskInstant.title.estimatedCompletion') }}
      </div>
      <div class="__subtitle">
        {{ formatDateTime(estimatedArrival) }}
      </div>
    </div>
    <hr class="separator" />
    <div class="fleet-popover-body">
      <div class="__title">
        {{ $t('fleetTaskInstant.title.driver') }}
      </div>
      <div class="__subtitle">
        {{ driver ?? '-' }}
      </div>
    </div>
  </b-popover>
</template>

<script>
import { formatIndexDate } from '@/helpers/tzDate'

export default {
  name: 'FleetOrderTooltip',
  props: {
    fleetNumber: {
      type: String,
      default: '-',
    },
    driver: {
      type: String,
      default: '-',
    },
    estimatedArrival: {
      type: String,
      default: null,
    },
  },
  methods: {
    formatDateTime(dateTime) {
      return dateTime ? `${formatIndexDate(dateTime).date} ${formatIndexDate(dateTime).time}` : '-'
    },
  },
}
</script>

<style lang="scss" scoped>
.custom-tooltip {
  background-color: $popover-bg !important;
  color: $mep-color-text !important;
  min-width: 150px !important;
  max-width: 250px !important;
  border: 1px solid $teal-100;
  box-shadow: 0 4px 8px rgba(16, 24, 64, 0.08) !important;

  font-family: $font-family-sans-serif;
  font-size: 12px;
  font-weight: 500;
  padding: 6px 0;
}

.fleet-popover-header {
  background-color: $mep-color-text-400 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 0;
  color: $mep-color-text;

  .mc-text-fleet-number {
    color: $white;
  }
}

.fleet-popover-body {
  padding: 10px;

  .__title {
    font-size: 10px;
    color: $mep-color-text-300;
  }

  .__subtitle {
    font-size: 11px;
    color: $mep-color-text-400;
    font-weight: 600;
  }
}

.separator {
  border-top: 1px solid $gray-600;
  margin: 0;
}
</style>
